import { Link } from 'react-router-dom';
import { videos } from '@/mocks/data';

export default function LatestContent() {
  const latestVideos = videos.slice(0, 4);

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">最新内容</h2>
          <p className="text-sm text-foreground-500 mt-3">实时更新，发现最新短视频趋势</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {latestVideos.map((video, idx) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group flex flex-col sm:flex-row gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-background-300/60 transition-all cursor-pointer"
            >
              <div className="relative w-full sm:w-48 aspect-video sm:aspect-auto rounded-lg overflow-hidden flex-shrink-0">
                <img src={video.thumbnail} alt={video.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                <div className="absolute bottom-2 right-2 bg-foreground-950/75 text-background-50 text-xs px-2 py-0.5 rounded">{video.duration}</div>
              </div>
              <div className="flex-1 flex flex-col justify-between min-w-0">
                <div>
                  <div className="flex items-center gap-2 mb-2">
                    <span className="px-2 py-0.5 text-xs rounded-full bg-accent-100 text-accent-800 whitespace-nowrap">{video.category}</span>
                    <span className="text-xs text-foreground-400">{video.date}</span>
                    {idx === 0 && <span className="px-2 py-0.5 text-xs rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">最新</span>}
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1 line-clamp-2 leading-snug font-heading">{video.title}</h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">{video.description}</p>
                </div>
                <div className="flex items-center gap-3 mt-3">
                  <img src={video.authorAvatar} alt={video.author} className="w-5 h-5 rounded-full object-cover" loading="lazy" />
                  <span className="text-xs text-foreground-500">{video.author}</span>
                  <span className="text-xs text-foreground-400 flex items-center gap-1"><i className="ri-eye-line"></i>{(video.views / 10000).toFixed(0)}万次</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}